import React, { useState } from 'react';
import { ExternalLink, Play } from 'lucide-react';

import { useLanguage } from '../context/LanguageContext';
import SEO, { breadcrumbSchema } from '../components/SEO';

const API = process.env.REACT_APP_BACKEND_URL;

const PRESS = [
  {
    pub: 'RV Business',
    logo: null,
    image: 'https://images.unsplash.com/photo-1663422938760-d6a40dbd2463?crop=entropy&cs=srgb&fm=jpg&w=600&q=80',
    date: 'November 2025',
    label: 'AEONrv Surpasses 100 All-Season Electric-Cabin RVs',
    quote: '"Traditional RVs rely on dated materials. AEONrv took the opposite approach, building a vehicle with modern technology and a fully insulated composite cabin engineered for true four-season adventure."',
    url: 'https://rvbusiness.com/aeonrv-surpasses-100-all-season-electric-cabin-rvs/',
  },
  {
    pub: 'Northern Nevada Business Weekly',
    logo: 'https://customer-assets.emergentagent.com/job_dashboard-114/artifacts/7nmp4lmb_image.png',
    image: 'https://nevadanewsgroup.media.clients.ellingtoncms.com/img/photos/2025/05/29/IMG_7704_t670.jpg',
    date: 'June 2025',
    label: 'AEONrv Seeks to Build World\'s Most High-Tech RV Plant',
    quote: '"We call it a Yeti cooler on wheels – it\'s so different from anything else on the market in how well insulated it is. You can camp in 95 degree weather and be completely comfortable."',
    url: 'https://www.nnbw.com/news/2025/jun/04/aeonrv-seeks-to-build-the-worlds-most-high-tech-automated-rv-manufacturing-plant/',
  },
  {
    pub: 'Victoria News',
    logo: 'https://vicnews.com/wp-content/uploads/sites/2/2025/10/VictoriaNews.png',
    image: 'https://vicnews.com/wp-content/uploads/sites/2/2025/01/250120-vne-arctic-expeditions.jpg',
    date: 'January 2025',
    label: 'Esquimalt Company Vital Part of Treks to North and South Poles',
    quote: '"This was just a game-changer. They said, \'We can hang out inside. We can make meals inside… We want to do this again\'."',
    url: 'https://vicnews.com/2025/01/21/cold-comfort-esquimalt-company-a-vital-part-of-treks-to-north-and-south-poles/',
  },
  {
    pub: 'Truck Camper Magazine',
    logo: null,
    image: `${API}/api/media-img/tc-campers-intro.jpg`,
    date: 'October 2024',
    label: 'Introducing TOTAL COMPOSITES Truck Campers',
    quote: '"TOTAL COMPOSITES offers 100-percent composite hard-side truck campers. Shipped in kits, assembled by builder/partners, and custom finished to your specifications — a potential game changer."',
    url: 'https://www.truckcampermagazine.com/news/introducing-total-composites-truck-campers/',
  },
  {
    pub: 'Truck Camper Magazine',
    logo: null,
    image: `${API}/api/media-img/outpost-intro.jpg`,
    date: 'October 2024',
    label: 'Introducing Outpost Campers',
    quote: '"From Bayfield, Colorado comes Outpost Campers, an all-new high-end production truck camper company based on TOTAL COMPOSITES panel construction."',
    url: 'https://www.truckcampermagazine.com/news/introducing-outpost-campers/',
  },
  {
    pub: 'Expedition Portal',
    logo: null,
    image: `${API}/api/media-img/outpost-65.jpg`,
    date: 'October 2024',
    label: 'The Outpost 6.5 — Well-Equipped & Affordable',
    quote: '"Outpost Campers recently unveiled their latest model, the Outpost 6.5 — an ideal choice for those looking to combine mobility with comfort on full-size half-ton trucks."',
    url: 'https://expeditionportal.com/the-outpost-6-5-camper-is-well-equipped-and-affordable/',
  },
  {
    pub: 'Outside Online',
    logo: null,
    image: `${API}/api/media-img/outside-diy.jpg`,
    date: 'October 2024',
    label: 'TOTAL COMPOSITES Truck Camper DIY Build',
    quote: '"Adventure vehicles, overland rigs, and campers have exploded in popularity over recent years… So I decided to build my own."',
    url: 'https://www.outsideonline.com/outdoor-gear/cars-trucks/total-composites-truck-camper-diy-build/',
  },
  {
    pub: 'Truck Camper Magazine',
    logo: null,
    image: 'https://customer-assets.emergentagent.com/job_dashboard-114/artifacts/b16ffjyd_image.png',
    date: 'April 2024',
    badge: 'Best Truck Camper Innovation 2023',
    label: 'Readers\' Choice Awards 2023',
    quote: '"The winners of the 11th annual Truck Camper Magazine Readers\' Choice Awards for Best Hard Side Truck Camper, Best Pop-Up Truck Camper, and Best Truck Camper Innovation of the year."',
    url: 'https://www.truckcampermagazine.com/off-road/extreme-rigs/ready-for-the-world/',
  },
  {
    pub: 'Truck Camper Magazine',
    logo: null,
    image: `${API}/api/media-img/landrover-build.jpg`,
    date: 'April 2024',
    label: 'Ready for the World — Land Rover Build',
    quote: '"Imagine taking apart your truck, rebuilding it in a different configuration, and then starting fresh with a TOTAL COMPOSITES camper shell. What could you do? Darn near anything!"',
    url: 'https://www.truckcampermagazine.com/off-road/extreme-rigs/ready-for-the-world/',
  },
  {
    pub: 'Cowboy State Daily',
    logo: `${API}/api/media-img/cowboy-logo.webp`,
    image: `${API}/api/media-img/cowboy-north-pole.jpg`,
    date: 'December 2023',
    label: '6x6 Trucks That Drove to the North Pole',
    quote: '"Two 6x6 customized F-350 trucks recently drove from Cheyenne to the Magnetic North Pole across frozen sea ice."',
    url: 'https://cowboystatedaily.com/2023/12/17/wyoming-shop-builds-badass-6x6-trucks-that-drove-from-cheyenne-to-north-pole-2/',
  },
  {
    pub: 'Truck Camper Adventure',
    logo: 'https://customer-assets.emergentagent.com/job_dashboard-114/artifacts/sqlv6zk8_image.png',
    image: 'https://customer-assets.emergentagent.com/job_dashboard-114/artifacts/tnclih00_989E790E-FEDC-4A09-A709-BC85C7624177_1_105_c.jpeg',
    date: 'June 2023',
    label: 'Demand for TC Shells Skyrockets',
    quote: '"It really caught us by surprise how big the demand was for our truck camper shells. Since our introduction in 2021, we have teamed up with eight commercial partners. Sales have increased by more than 50 percent each year."',
    url: 'https://www.truckcamperadventure.com/demand-for-total-composites-camper-shells-continues-to-skyrocket/',
  },
  {
    pub: 'autoevolution',
    logo: 'https://customer-assets.emergentagent.com/job_dashboard-114/artifacts/gnm9cfrd_image.png',
    image: 'https://s1.cdn.autoevolution.com/images/news/north-america-s-total-composites-achieves-the-unthinkable-campers-at-the-north-pole-216228-7.jpg',
    date: 'June 2023',
    label: 'TOTAL COMPOSITES Achieves the Unthinkable: Campers at the North Pole',
    quote: '"Building a habitat that can endure the world\'s most treacherous landscapes takes hard work and know-how. Total Composites specializes in building and crafting machines that can survive terrains ranging from Death Valley to the North Pole."',
    url: 'https://www.autoevolution.com/news/north-america-s-total-composites-achieves-the-unthinkable-campers-at-the-north-pole-216228.html',
  }
];

const VIDEOS = [
  { id: '8wjU9bomcUI', title: 'TOTAL COMPOSITES Build Feature', channel: 'Total Composites', partner: 'Total Composites', partnerUrl: 'https://totalcomposites.com/' },
  { id: 'Kuh3GVhi61M', title: 'TransGlobal Car Expedition in the Arctic', channel: 'Emilgrims', partner: 'Arctic Trucks', partnerUrl: 'https://arctictrucks.com/' },
  { id: 'LwhVMloRvvY', title: 'Magnetic North Pole Expedition 2023', channel: 'Total Composites', partner: 'Arctic Trucks', partnerUrl: 'https://arctictrucks.com/' },
  { id: 'USzkQp7gHXg', title: 'Transglobal Car Expedition — South Pole', channel: 'Total Composites', partner: 'Arctic Trucks', partnerUrl: 'https://arctictrucks.com/' },
  { id: 'KRkqXyQqLdo', title: 'Transglobal Car Expedition — Journey', channel: 'Total Composites', partner: 'Arctic Trucks', partnerUrl: 'https://arctictrucks.com/' },
  { id: 'PDzDE5ZYIxg', title: 'TOTAL COMPOSITES Camper at the North Pole!', channel: 'Total Composites', partner: 'Arctic Trucks', partnerUrl: 'https://arctictrucks.com/' },
  { id: 'jSp_mPWyhHo', title: 'The Outpost 6.5 Cabover Truck Camper Tour', channel: 'Far Out Stoke', partner: 'Outpost Campers', partnerUrl: 'https://outpost-campers.com/' },
  { id: 'BmbF0akhQ-w', title: '40+ Truck Campers at Overland Expo West \'24', channel: 'Welcome To The Outdoors', partner: 'Ascent Conversions', partnerUrl: 'https://www.ascentconversions.com/' },
  { id: 'nkXDY1s0dAg', title: 'ALL NEW AEONrv Detailed Walkthrough', channel: 'Chad and Paul', partner: 'Aeon RV', partnerUrl: 'https://aeonrv.com/' },
  { id: 'XVg3ZEJcZLs', title: 'True Four Season Truck Camper', channel: 'Welcome To The Outdoors', partner: 'Bear Adventure Vehicles', partnerUrl: 'https://www.bearvehicles.com/' },
  { id: 'ZrOX8HvUwUA', title: 'Acela Expedition Truck Baja Road Trip', channel: 'gaiabella31', partner: 'Acela Truck', partnerUrl: 'https://www.acelatruck.com/' },
];

const VideoCard = ({ video }) => {
  const [playing, setPlaying] = useState(false);
  // Use hqdefault for videos that don't have maxresdefault
  const thumbnailQuality = ['LwhVMloRvvY', 'ZrOX8HvUwUA'].includes(video.id) ? 'hqdefault' : 'maxresdefault';
  return (
    <div className="group border border-gray-100 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 flex flex-col bg-white">
      <div style={{ position: 'relative', paddingBottom: '56.25%' }}>
        {playing ? (
          <iframe src={`https://www.youtube.com/embed/${video.id}?autoplay=1`} title={video.title}
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
            allow="autoplay; fullscreen" allowFullScreen />
        ) : (
          <div style={{ position: 'absolute', inset: 0, cursor: 'pointer' }} onClick={() => setPlaying(true)}>
            <img src={`https://img.youtube.com/vi/${video.id}/${thumbnailQuality}.jpg`} alt={video.title}
              className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
              onError={e => { e.target.src = `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`; }} />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-12 h-12 rounded-full flex items-center justify-center transition-transform group-hover:scale-110"
                style={{ backgroundColor: '#E8520A', boxShadow: '0 4px 20px rgba(232,82,10,0.45)' }}>
                <Play size={18} fill="white" stroke="none" style={{ marginLeft: 2 }} />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="px-5 py-4 flex flex-col gap-2 flex-1">
        <p className="text-sm font-bold text-gray-900 leading-snug">{video.title}</p>
        <div className="flex items-center justify-between mt-auto">
          <p className="text-xs text-gray-400">{video.channel}</p>
          <a href={video.partnerUrl} target="_blank" rel="noopener noreferrer"
            className="text-xs font-bold uppercase tracking-widest flex items-center gap-1 hover:opacity-75 transition-opacity"
            style={{ color: '#E8520A', fontSize: '0.6rem' }}>
            {video.partner} <ExternalLink size={8} />
          </a>
        </div>
      </div>
    </div>
  );
};

const Media = () => {
  const { language } = useLanguage();
  const fr = language === 'fr';
  return (
  <div className="min-h-screen pt-[76px]" style={{ backgroundColor: '#000' }}>
    <SEO
      title="Press & Media"
      description="Total Composites in the press — media coverage, articles, videos, and news features about our expedition truck campers and composite technology."
      path="/media"
      keywords="Total Composites press, truck camper news, expedition camper media, composite camper reviews, overlanding articles"
      jsonLd={breadcrumbSchema([
        { name: 'Home', path: '/' },
        { name: 'Press & Media', path: '/media' }
      ])}
    />

    {/* Header — same as Partners/About/Expedition */}
    <section className="bg-black py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#E8520A', letterSpacing: '0.15em' }}>
          {fr ? 'Couverture et analyses' : 'Coverage & Insights'}
        </p>
        <h1 className="text-4xl lg:text-5xl font-black text-white mb-4 uppercase" style={{ fontFamily: 'Inter, sans-serif' }}>
          {fr ? 'Presse et médias' : 'Press & Media'}
        </h1>
        <p className="text-gray-400 max-w-2xl leading-relaxed text-sm">
          {fr
            ? 'Découvrez ce que les principaux sites web, magazines et experts de l’industrie disent de TOTAL COMPOSITES et de nos produits — des expéditions arctiques aux prix d’innovation overland.'
            : 'Explore what leading websites, magazines, and industry experts have to say about TOTAL COMPOSITES and our products — from Arctic expeditions to overland innovation awards.'}
        </p>
      </div>
    </section>

    {/* Press Coverage — white section */}
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-4 mb-10">
          <h2 className="text-2xl font-black text-gray-900 whitespace-nowrap" style={{ fontFamily: 'Inter, sans-serif' }}>
            {fr ? 'Couverture en vedette' : 'Featured Coverage'}
          </h2>
          <div className="flex-1 h-px bg-gray-200" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRESS.map((item, i) => (
            <a key={item.url} href={item.url} target="_blank" rel="noopener noreferrer"
              className="group flex flex-col border border-gray-100 rounded-xl overflow-hidden shadow-sm hover:shadow-lg hover:border-orange-200 transition-all duration-300 bg-white"
              style={{ textDecoration: 'none' }}>
              {/* Thumbnail */}
              <div className="relative overflow-hidden" style={{ height: 180 }}>
                <img src={item.image} alt={item.label}
                  className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
                {item.badge && (
                  <div className="absolute top-3 left-3 text-white text-xs font-black uppercase px-2.5 py-1 rounded"
                    style={{ backgroundColor: '#E8520A', fontSize: '0.58rem', letterSpacing: '0.08em' }}>
                    {item.badge}
                  </div>
                )}
              </div>
              {/* Body */}
              <div className="flex flex-col flex-1 border-t border-gray-100">
                {/* Highlighted top: date + logo + title */}
                <div className="flex flex-col gap-2 p-5 pb-4" style={{ backgroundColor: '#f8f8f8', borderBottom: '1px solid #efefef' }}>
                  <p className="text-xs text-gray-400 font-medium uppercase tracking-widest">{item.date}</p>
                  {item.logo ? (
                    <img src={item.logo} alt={item.pub}
                      className="object-contain"
                      style={{ height: 22, width: 'auto', objectPosition: 'left', maxWidth: 140, opacity: 1 }}
                      onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
                    />
                  ) : null}
                  {!item.logo && (
                    <span className="text-xs font-black text-gray-700 uppercase tracking-widest" style={{ letterSpacing: '0.08em' }}>{item.pub}</span>
                  )}
                  <p className="text-xs font-black text-gray-900 uppercase leading-snug" style={{ letterSpacing: '0.04em' }}>
                    {item.label}
                  </p>
                </div>
                {/* Quote + CTA */}
                <div className="flex flex-col gap-2.5 p-5 flex-1">
                  <p className="text-xs text-gray-500 leading-relaxed flex-1 italic">{item.quote}</p>
                  <div className="border-t border-gray-100 pt-3 mt-1">
                    <p className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-1.5">{item.pub}</p>
                    <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest" style={{ color: '#E8520A', fontSize: '0.62rem' }}>
                      <ExternalLink size={10} /> {fr ? 'Lire l’article' : 'Read Article'}
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>

    {/* Videos — alternating gray-50 section */}
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-4 mb-10">
          <h2 className="text-2xl font-black text-gray-900 whitespace-nowrap" style={{ fontFamily: 'Inter, sans-serif' }}>
            {fr ? 'Vidéos et reportages' : 'Videos & Features'}
          </h2>
          <div className="flex-1 h-px bg-gray-200" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {VIDEOS.map(v => <VideoCard key={v.id} video={v} />)}
        </div>
      </div>
    </section>

    {/* CTA — same pattern as Partners "Join Our Network" */}
    <section className="bg-gray-50 py-20">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <h2 className="text-3xl font-black text-gray-900 mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
          {fr ? 'Demandes médias' : 'Media Inquiries'}
        </h2>
        <p className="text-gray-500 mb-10 text-sm leading-relaxed">
          {fr
            ? 'Demandes de presse, partenariats éditoriaux ou collaborations médiatiques — contactez directement notre équipe.'
            : 'Press requests, editorial partnerships, or media collaborations — reach out to our team directly.'}
        </p>
        <a href="/contact"
          className="inline-flex items-center gap-2 px-7 py-3.5 font-bold text-white rounded-full text-sm transition-all duration-200 hover:opacity-90 hover:scale-105"
          style={{ backgroundColor: '#E8520A' }}>
          {fr ? 'CONTACTEZ-NOUS' : 'CONTACT US'} <ExternalLink size={14} />
        </a>
      </div>
    </section>

  </div>
);
};

export default Media;
